import { Navigate, useLocation } from "react-router-dom";

import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";

const TrialExpiredProtectedRoute = ({ children }: { children: JSX.Element }) => {
    // Use isAuthenticatedState (reactive) instead of isAuthenticated() (function)
    // This ensures component re-renders when auth state changes
    const { isAuthenticatedState, emailVerified, isTrial, knowledgeBase } =
        FirebaseAuthContainer.useContainer();
    const location = useLocation();

    return isAuthenticatedState ? (
        emailVerified &&
        isTrial &&
        knowledgeBase?.expiringTrialPeriod != null &&
        knowledgeBase?.expiringTrialPeriod < 1 ? (
            children
        ) : (
            <Navigate to="/" />
        )
    ) : (
        <Navigate to="/login" state={{ from: location }} />
    );
};

export default TrialExpiredProtectedRoute;
